import Page, { background } from "./page";

import { ReplicaItemType } from "types";
import thumbnail from "./gallery/promo_00.jpg";

const data: ReplicaItemType = {
  id: "marauders-map-v7-prisoner-of-azkaban-prototype",
  name: "Marauder's Map V7 - Prisoner of Azkaban (Prototype)",
  nameFormatted: {
    primary: "Prototype",
    secondary: "Marauder's Map V7",
    tertiary: "Prisoner of Azkaban",
  },
  page: <Page />,
  thumbnail,
  background,
};

export default data;
